import { atomWithStorage } from "jotai/utils";

export type User = Record<string, never>;

const defaultUserState: User = {};

const customStorage = {
	getItem: (key: string): User => {
		const item = localStorage.getItem(key);
		return item
			? { ...defaultUserState, ...JSON.parse(item) }
			: defaultUserState;
	},
	setItem: (key: string, value: User | null): void => {
		if (value !== null) {
			localStorage.setItem(key, JSON.stringify(value));
		} else {
			localStorage.removeItem(key);
		}
	},
	removeItem: (key: string): void => {
		localStorage.removeItem(key);
	},
};

export const userState = atomWithStorage<User>(
	"USER_STATE",
	defaultUserState,
	customStorage,
	{ getOnInit: true },
);
